import { SvgIcon, type SvgIconProps } from '@mui/material';

/** Simple walkie-talkie handset icon. */
export function WalkieTalkieIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M8 3h8a2 2 0 0 1 2 2v1.1l1.4.7a1 1 0 0 1 .6.9V11a1 1 0 0 1-1 1h-1v5a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-5H5a1 1 0 0 1-1-1V7.7a1 1 0 0 1 .6-.9L6 6.1V5a2 2 0 0 1 2-2zm0 2v1h8V5H8zm-1 4v5h2v-1h6v1h2V9H7zm3 2h4v2h-4v-2z"
      />
      <path fill="currentColor" d="M11 2h2v2h-2V2zm-1 18h4v1h-4v-1z" opacity="0.85" />
    </SvgIcon>
  );
}
